import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterLoadingStateSliceInterface {
  loadingFilterName: string;
}

const initialState: FilterLoadingStateSliceInterface = {
  loadingFilterName: "",
};

const FilterLoadingStateSlice = createSlice({
  name: "FilterLoadingState",
  initialState,
  reducers: {
    setLoadingFilterName: (
      state: FilterLoadingStateSliceInterface,
      action: PayloadAction<any>
    ) => {
      state.loadingFilterName = action.payload;
    },
  },
});

export const { setLoadingFilterName } = FilterLoadingStateSlice.actions;
export default FilterLoadingStateSlice.reducer;
